"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const inquiries = [{
  question: "How do I book a professional residential cleaning service?",
  answer: "Booking is simple through our online portal or by phone. We offer one-time deep cleans or recurring weekly, bi-weekly, and monthly schedules tailored to your home's specific needs and your personal lifestyle."
}, {
  question: "Do I need to be present during the cleaning appointment?",
  answer: "Most of our clients prefer to provide a key or entry code, but you are welcome to be home. Our team is fully vetted and insured, ensuring your property is treated with the utmost respect and care."
}, {
  question: "What specific tasks are included in an Airbnb turnover?",
  answer: "We provide a comprehensive checklist including linen laundering, surface sanitization, restocking essentials, and a final staging to ensure your next guests enjoy a five-star experience from the moment they walk in."
}, {
  question: "Are your cleaning products safe for pets and children?",
  answer: "Yes, we prioritize the health of your family. We use eco-friendly, non-toxic cleaning solutions that effectively sanitize your home without leaving behind harsh chemical residues or overwhelming artificial scents."
}, {
  question: "How do you manage secure access to my property?",
  answer: "Security is our priority. We utilize encrypted key management systems or secure lockbox codes. Your access information is only shared with the specific cleaning professionals assigned to your home for that scheduled service."
}];
export default function FrameworkInquiries() {
  return <section data-section-id="223531" id="common-questions" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-foreground)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-foreground)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_20%,transparent_100%)]" />
      </div>

      <div className="max-w-3xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="font-default text-3xl md:text-5xl font-semibold tracking-tight text-foreground">
            Common Questions
          </h2>
          <div className="h-px w-24 bg-primary/50 mx-auto mt-8" />
        </div>

        <Accordion type="single" collapsible className="w-full space-y-2">
          {inquiries.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="group relative border-b border-border/50 overflow-hidden transition-colors duration-500 data-[state=open]:border-primary/40 rounded-none px-2 sm:px-4">
              {}
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,var(--color-primary)_0%,transparent_80%)] opacity-0 group-data-[state=open]:opacity-[0.06] transition-opacity duration-700 pointer-events-none z-0" />

              <AccordionTrigger className="relative z-10 py-6 hover:no-underline group/trigger">
                <div className="flex items-baseline gap-4 sm:gap-8 text-left w-full pr-4">
                  <span className="font-mono text-xs sm:text-sm text-primary/50 group-hover/trigger:text-primary transition-colors duration-300 shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-default text-base sm:text-lg tracking-wide text-primary group-hover/trigger:text-primary/80 transition-colors duration-300">
                    {faq.question}
                  </span>
                </div>
              </AccordionTrigger>
              
              <AccordionContent className="relative z-10 pb-8 pt-2">
                <div className="pl-8 sm:pl-14 pr-4">
                  <p className="text-foreground leading-relaxed font-default font-normal text-sm sm:text-base">
                    {faq.answer}
                  </p>
                </div>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}